import { createPuzzleProgressStore } from "../shared-sortaballs/puzzle-progress"

export type { PuzzleProgress } from "../shared-sortaballs/puzzle-progress"

export const { checkIfSolved, loadProgress, saveProgress } =
	createPuzzleProgressStore("sortaballs-10-colors-puzzle-progress")